var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.post_href,"target":"_blank"}},[_c('b-card',{staticClass:"mb-2",attrs:{"title":_vm.created_time_formatted}},[_c('p',{staticClass:"px-3",domProps:{"innerHTML":_vm._s(_vm.post.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }